import React, { useCallback, memo } from 'react';
import { SelectOption } from '@leasequery/lq.react-component-library/dist/models';
import { ReportCurrency, ReportType } from '../../../../models';
import ReportSettingPIT from '../ReportSettingPIT';
import { ReportTypeSetting } from '../../../../models/reportTypeSetting';

interface ReportSettingDeleteBalanceProps {
  onChange: (updatedValue: ReportSettingDeleteBalanceState) => void;
  reportSettingState: ReportSettingDeleteBalanceState;
  reportTypeSetting: ReportTypeSetting;
  isAllowPIT: boolean;
}

export interface ReportSettingDeleteBalanceState {
  selectedCurrency: SelectOption<ReportCurrency>;
  isValid: boolean;
}

function ReportDateSettingDeleteBalance({
  onChange,
  reportSettingState,
  isAllowPIT,
  reportTypeSetting,
}: ReportSettingDeleteBalanceProps): JSX.Element {
  return (
    <>
      <ReportSettingPIT
        reportType={ReportType.deleteBalance}
        reportSettingState={reportSettingState}
        reportTypeSetting={reportTypeSetting}
        customCalendarSettings={null}
        isAllowPIT={isAllowPIT}
        onChange={useCallback(
          (state) => onChange(state as ReportSettingDeleteBalanceState),
          [onChange],
        )}
      />
    </>
  );
}

export default memo(ReportDateSettingDeleteBalance);
